<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M10.0008 11.668C5.82578 11.668 2.42578 14.468 2.42578 17.918C2.42578 18.1513 2.60911 18.3346 2.84245 18.3346H17.1591C17.3925 18.3346 17.5758 18.1513 17.5758 17.918C17.5758 14.468 14.1758 11.668 10.0008 11.668Z"
      fill="currentColor"
    />
    <path
      d="M13.932 8.6263L13.132 7.8263C13.5487 7.2013 13.7904 6.4513 13.7904 5.64297C13.7904 3.44297 12.007 1.66797 9.81536 1.66797C7.6237 1.66797 5.83203 3.4513 5.83203 5.64297C5.83203 7.83464 7.61536 9.61797 9.80703 9.61797C10.6154 9.61797 11.3654 9.3763 11.9904 8.95964L12.7904 9.75963C12.9487 9.91797 13.157 9.99297 13.357 9.99297C13.5654 9.99297 13.7737 9.91797 13.9237 9.75963C14.2404 9.4513 14.2404 8.94297 13.932 8.6263Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'TaxpayersVerificationIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>